var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{class:'chat-app chat-app_'+_vm.site+' lang_'+_vm.lang,attrs:{"id":"urochat_app"}},[_c('Chat')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }